import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hideFullscreenFeatured } from "../redux/actions/fullscreenFeaturedAction";
import { Link, useLocation } from "react-router-dom";
import "./CampaignPage.sass";

// 404 not found layout
import { Result, Button } from "antd";
import { useHistory } from "react-router";
// css
import "./PageNotFound.sass";

import axios from "axios";
import { configPara } from "../components/globalComponents/APIUrlConfig";

export default function CampaignPage({ pageName }) {
  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Dispatch action to hide fullscreen featured
    dispatch(hideFullscreenFeatured());

    // Fetch data
    const fetchAddress = configPara.url + "/campaign/" + pageName;
    axios
      .get(fetchAddress, {
        auth: configPara.auth,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(response.data[0]);
        setData(response.data[0]);
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        setData({ error: "There was an error fetching the page data." });
        console.log(error);
      });
  }, [pageName, dispatch]); // Include dependencies

  // Show loading state while data is null
  if (!data) {
    return <div>Loading...</div>;
  }

  const { nid, title, type, status, url, body, error } = data;

  // Show error state if there's an error
  if (error) {
    return (
      <Result
        status="404"
        title="404"
        subTitle={error}
        extra={
          <Button type="primary" onClick={() => history.push("/search")}>
            Back to Search
          </Button>
        }
      />
    );
  }

  // Render page content
  return (
    <div id="page_content" style={{ fontFamily: "sans-serif" }}>
      <div
        className="site_container"
        dangerouslySetInnerHTML={{ __html: body }}
      ></div>
    </div>
  );
}